import React, { useEffect,useState } from "react";
import unsplash from "../api/unsplash";
import { useNavigate } from "react-router-dom";
import { CSpinner } from "@coreui/react";
import {Box,IconButton,Dialog,DialogTitle,DialogContent,Alert,Button,TextField,DialogActions,Select,OutlinedInput,MenuItem,FormControl,Card,Grid,CardContent} from '@mui/material';
import { DataGrid, GridToolbar, itIT } from '@mui/x-data-grid';
import {Add, Circle} from "@mui/icons-material";
import GlobalSnackbar from "./Snackbar";


const columns = [    {
        
  field: 'new',
  headerName: '',
  width: 10,
  headerAlign: 'center',
  align: 'center',
  sort: 'asc',
  renderCell: (params) => ( //mi aiuta a mettere il valore
  <>
  {params.row.new?<Circle sx={{color:"green",width:"10px",height:"10px"}}/>:""}
</>

  )
},{
        
  field: 'RagioneSociale',
  headerName: 'RagioneSociale',
  //width: 400,
  flex:1,
  headerAlign: 'center',
  align: 'center',
  sort: 'asc'
},{ field: 'SedeIndirizzo',
headerName: 'Indirizzo',
//width: 300,
flex:1,
headerAlign: 'center',
align: 'center',
sort: 'asc' 
},{ field: 'SedeLocalita',
headerName: 'Località',
//width: 300,
flex:1,
headerAlign: 'center',
align: 'center',
sort: 'asc'
},{ field: 'SedeCAP',
headerName: 'Cap',
//width: 300,
flex:1,
headerAlign: 'center',
align: 'center',
sort: 'asc'
}]



const Clienti = () =>{

const [clienti,setClienti] = useState();
const [clientiVisibili,setClientiVisibili] = useState();
const [loading, setLoading] = useState(true);
const navigate = useNavigate();
const [openSnack, setOpenSnack] = useState(false);
const handleCloseSnack = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }
  setOpenSnack(false);
}
const [snack,setSnack] = useState({severity:"success",messaggio:"Salvataggio Effettuato correttamente",open:false});



useEffect(() => {// è un loop qui carico i dati 
    const fetchData = async () =>{
        setLoading(true);
      try {
    
                  let response = await  unsplash.get('clienti', {headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwt')}`}
                });
                                        setClienti(response.data.data)
                                        setClientiVisibili(response.data.data)
                                
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    }

    fetchData();
   
  }, []);


 //importante per l'api l'arrayvuoto
 const handleChange = (e) => { // filtro
 


   if(e.target.value == ""){
    setClientiVisibili(clienti);
   
  }else{
    var clientiX = []; // popolo l'array 
  var i;
  for (i =0 ;i < clienti.length;i++){
    if (clienti[i].RagioneSociale.toLowerCase().includes((e.target.value.toLowerCase() ))){
      clientiX.push(clienti[i]);
    }
  }
  setClientiVisibili(clientiX);
  }

  }

  const handleSaveData = async(cliente) => {
    try{ //AGGIUNGERE LA CREAZIONE DELLA SEDE
      let responseCliente = await unsplash.post('clienti',{cliente:cliente},
            { headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            }}  );
    setSnack({severity:"success",messaggio:"Cliente creato con successo"});
    setOpenSnack(true);
    cliente.new = true;
    cliente.ID = responseCliente.data.message.insertId;
    let c = [...clienti];
    c.unshift(cliente); //aggiungo in prima posizione
    console.log(c)
                          setClienti(c);
                         setClientiVisibili(c);
        
    }catch(error){
    console.log(error);
    setSnack({severity:"error",messaggio:"Errore durante la creazione del cliente"})
    setOpenSnack(true);
    }
    

  }

return (
  <>  <GlobalSnackbar severity={snack.severity} messaggio={snack.messaggio} openSnack={openSnack} handleCloseSnack={handleCloseSnack}/>
  <Grid item xs={12}>

<Card>
  <CardContent>
<div>
<div ><center >

<div className="form-outline mb-4 input-group" style={{width:"33%"}}>
<span class="input-group-text bg-transparent">
            <i class="bi bi-search" ></i>
            </span>
<input onChange={handleChange} className="form-control form-control-lg border-left-0"/>
     
           
          </div>
  
  
  
 </center></div>
{

    clientiVisibili === undefined ? (<p> <center><CSpinner color="primary"/></center></p>):(
      <>
      <NewClientModal myFunction={handleSaveData}/>
      <Box
      sx={{
          height: 700,
          width: 1
      }}
      >
  <DataGrid sx={{fontSize:12}}
                                components={{ Toolbar: GridToolbar }}
                                localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                                rows={clientiVisibili}
                                columns={columns}
                                getRowId={(row) => row.ID}
                                pageSize={20}
                                initialState={{
                                    sorting: {
                                      sortModel: [{ field: 'matricola', sort: 'desc' }],
                                    },
                                  }}
                            
                                disableSelectionOnClick
                                onRowClick={ async (params,event)=> 
                                    {
                                      let idCliente= params.row.ID;
                                      let ragSoc = params.row.RagioneSociale;
                                      
                                      navigate('/dettaglioCliente',{state:{idC: idCliente,RagioneSociale:ragSoc}})
                               
                                    }    
                                }
                                />
        </Box>
        </>
  

    )
    

}


</div>
</CardContent>
</Card>
</Grid>

</>)

}

export default Clienti;


const NewClientModal = (props) => {
  const [open, setOpen] = useState(false);
  const [cliente,setCliente] = useState();
  const [validation,setValidation] = useState();
  const handleClickOpen = () => {
    setCliente({RagioneSociale:"",SedeIndirizzo:"",SedeLocalita:"",SedeCAP:""});
    setValidation({RagioneSociale:false,SedeIndirizzo:false,SedeLocalita:false,SedeCAP:false});
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

const handleChange = (e) => {
let c = {...cliente};
c[e.target.name] = e.target.value;
setCliente(c);
}

const handleSave = async () => {
var check = false;
let val = {...validation}
if(cliente.RagioneSociale===""|| cliente.RagioneSociale===null){
  val.RagioneSociale = true;
  check=true;
}else{
 val.RagioneSociale = false;
}
if(cliente.SedeIndirizzo===""|| cliente.SedeIndirizzo===null){
  val.SedeIndirizzo = true;
  check=true;
}else{
 val.SedeIndirizzo = false;
}
if(cliente.SedeLocalita===""|| cliente.SedeLocalita===null){
  val.SedeLocalita = true;
  check=true;
}else{
 val.SedeLocalita = false;
}

if(cliente.SedeCAP===""|| cliente.SedeCAP===null){
  val.SedeCAP = true;
  check=true;
}else{
 val.SedeCAP = false;
}

setValidation(val);


if(!check){


props.myFunction(cliente);
}

}



  return (
    <div>
       <IconButton aria-label="edit" onClick={handleClickOpen}>
    <Add 
    style={{height:"2rem",width:"2rem",color:"#2264ae"}}
    
      />
  </IconButton>
      <Dialog open={open} onClose={handleClose} 
      fullWidth={true}
        maxWidth="md">
        <DialogTitle>Inserisci nuovo cliente</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
          <TextField
          error={validation?.RagioneSociale}
            autoFocus
            margin="dense"
            name="RagioneSociale"
            label="Ragione Sociale"
            type="text"
            fullWidth
            value={cliente?.RagioneSociale}
            onChange={handleChange}
            variant="outlined"
            helperText={validation?.RagioneSociale?"Campo obbligatorio":""}
          />
          </Grid>
          <Grid item xs={12} md={6}>
          <TextField
          error={validation?.SedeIndirizzo}
            autoFocus
            margin="dense"
            name="SedeIndirizzo"
            label="Indirizzo"
            type="text"
            fullWidth
            value={cliente?.SedeIndirizzo}
            onChange={handleChange}
            variant="outlined"
            helperText={validation?.SedeIndirizzo?"Campo obbligatorio":""}
          />
          </Grid>
          <Grid item xs={12} md={6}>
          <TextField
            error={validation?.SedeLocalita}
            autoFocus
            margin="dense"
            name="SedeLocalita"
            label="Località"
            type="text"
            fullWidth
            value={cliente?.SedeLocalita}
            onChange={handleChange}
            variant="outlined"
            helperText={validation?.SedeLocalita?"Campo obbligatorio":""}
          />
          </Grid>
          <Grid item xs={12} md={6}>
          <TextField
            error={validation?.SedeCAP}
            autoFocus
            margin="dense"
            name="SedeCAP"
            label="Cap"
            type="text"
            fullWidth
            value={cliente?.SedeCAP}
            onChange={handleChange}
            variant="outlined"
            helperText={validation?.SedeCAP?"Campo obbligatorio":""}
          />
          </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annulla</Button>
          <Button onClick={handleSave}>Crea</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}